<template>
  <el-container class="printer-statistics">
    <el-header class="box add bb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>统计查询</el-breadcrumb-item>
        <el-breadcrumb-item>合格证打印记录</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <el-main class="p15 pt0">
      <div class="box search mt20">
        <el-form :inline="true" :model="query" class="query-form" size="small">
          <el-form-item>
            <el-input
              v-model="query.gtin"
              placeholder="商品编码"
              clearable
              @clear="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="query.batchNumber"
              placeholder="批次编号"
              clearable
              @clear="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="query.companyName"
              placeholder="主体名称"
              clearable
              @clear="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="query.goodsName"
              placeholder="产品名称"
              clearable
              @clear="onSearch"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
            <el-button icon="el-icon-refresh" @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="box list mt20">
        <el-table
          border
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column type="selection" width="45" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column prop="batchNumber" label="批号" min-width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="gtin" label="商品编码" min-width="140" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="companyName" label="主体名称" min-width="160" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="creditCode" label="社会统一信用代码" min-width="180" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="goodsName" label="产品" min-width="160" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="goodsSpecification" label="规格" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="categoryName" label="分类" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="goodsManufacturer" label="生产商" min-width="120" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="originCountryName" label="产地" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="weights" label="重量" min-width="90" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="printCount" label="打印次数" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="screenshotCount" label="截图次数" min-width="100" align="center" :show-overflow-tooltip="true"></el-table-column>
        </el-table>

        <div class="pagination-wrap mt20">
          <el-pagination
            background
            :page-size="query.limit"
            :current-page="currentPage"
            layout="total, prev, pager, next, jumper"
            :total="total"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import api from "@/util/extra-api";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      query: {
        gtin: "",
        batchNumber: "",
        companyName: "",
        goodsName: "",
        page: 1,
        limit: 50,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      api
        .get("/v1/wx/printer/statistics", this.query)
        .then((res) => {
          const data = res.data || [];
          this.tableData = Array.isArray(data) ? data : data.list || data.records || data.rows || [];
          this.total = res.total || 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.currentPage = 1;
      this.query.page = 1;
      this.getList();
    },
    onReset() {
      this.query.gtin = "";
      this.query.batchNumber = "";
      this.query.companyName = "";
      this.query.goodsName = "";
      this.onSearch();
    },
    handleCurrentChange(page) {
      this.currentPage = page;
      this.query.page = page;
      this.getList();
    },
  },
};
</script>

<style scoped>
.printer-statistics {
  min-height: 100%;
  padding-bottom: 60px;
  background: #f3f5f8;
}

.query-form {
  padding: 18px 20px 0;
  text-align: left;
  background: #fff;
}

.list {
  padding: 10px 10px 20px;
  background: #fff;
  overflow: hidden;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 10px;
}

</style>
